import { Component, Input, OnInit, Output, EventEmitter, OnChanges } from "@angular/core";

@Component({
  selector: "app-select",
  templateUrl: "./select.component.html",
  styleUrls: ["./select.component.scss"],
})
export class SelectComponent implements OnInit, OnChanges{
  @Input() placeholder: string;
  @Input() items: string[];
  @Input() customClass: string[];
  @Input() activeItem: string;
  @Input() isDisabled: boolean = false
  // Truncates the selected value in the title to this many characters (0 = no limit)
  @Input() titleMaxLength = 0;

  @Output() selectChange = new EventEmitter<string>();

  val: string;

  get titleText() {
    const val = this.val ?? "";

    return this.titleMaxLength > 0 && val.length > this.titleMaxLength
      ? `${val.slice(0, this.titleMaxLength)}...`
      : val;
  }
  isOpen = false;
  isMobile = false;

  constructor() {}

  ngOnInit(): void {
    const ua = navigator.userAgent;
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(ua)) {
      this.isMobile = true;
    }

    if (this.activeItem) {
      this.val = this.activeItem;
    } else {
      this.val = this.placeholder;
    }
  }

  ngOnChanges() {    
    if (this.activeItem) {
      this.val = this.activeItem;
    } else {
      this.val = this.placeholder;
    }
  }

  toggleOpen() {
    this.isOpen = !this.isOpen;
  }

  setValue(value: string) {
    this.activeItem = value
    this.val = value;
    this.selectChange.emit(this.val);
  }

  closeDropdown() {
    this.isOpen = false
  }

  nativeChange(e: any) {
    this.setValue(e.target.value);
  }
}
